import { i18n } from '@/utils/i18n';
import axios, { AxiosError } from 'axios';
const { t } = i18n;
interface ApiError {
  result?: {
    displayableMessage?: boolean;
    errorCode?: null | string;
    errorMessageArgs?: null | string;
    exceptionClassName?: null | string;
    field?: null | string;
    message?: null | string;
    object?: null | string;
  };
}

// DEFAULT 에러 메시지 반영
export let DEFAULT_ERROR_MESSAGE = '';
export const setErrorMessage = (message: string) => {
  DEFAULT_ERROR_MESSAGE = t(message);
};
export const getDefaultErrorMessage = () => {
  return DEFAULT_ERROR_MESSAGE;
};

export const getErrorInfo = (err: AxiosError<ApiError>) => {
  let errorObj;

  if (Array.isArray(err.response?.data.result)) {
    errorObj = { ...err.response?.data?.result }[0];
  } else {
    errorObj = { ...err.response?.data?.result };
  }
  const {
    displayableMessage,
    errorCode,
    errorMessageArgs,
    exceptionClassName,
    field,
    message,
    object,
  } = errorObj;
  return {
    displayableMessage,
    errorCode,
    errorMessageArgs,
    exceptionClassName,
    field,
    message,
    object,
  };
};
